import React from 'react';
import { useCurrency } from '../../utils/currency.js';

export function CurrencyToggle() {
  const { region, setRegion } = useCurrency();
  return (
    <div className="currA" role="group" aria-label="Display currency">
      <button
        type="button"
        className={'currA-opt' + (region === 'IN' ? ' is-active' : '')}
        onClick={() => setRegion('IN')}
        aria-pressed={region === 'IN'}
      >
        ₹ INR
      </button>
      <button
        type="button"
        className={'currA-opt' + (region === 'US' ? ' is-active' : '')}
        onClick={() => setRegion('US')}
        aria-pressed={region === 'US'}
      >
        $ USD
      </button>
    </div>
  );
}
